<script>
import baseMixin from '@/mixins/baseMixin'
import BookingCardSkeletonLoader from '../skeleton/booking-card-skeleton-loader.vue'

export default {
  name: 'BookingCardListSkeletonLoader',
  components: { BookingCardSkeletonLoader },
  mixins: [baseMixin],
  props: {
    count: {
      type: Number,
      default: 6,
    },
  },
}
</script>

<template>
  <section>
    <BookingCardSkeletonLoader
      v-for="n in count"
      :key="`booking-card-list-item__skeleton-loader-${n}`"
    />
  </section>
</template>
